module.exports = __webpack_public_path__ + "img/Sappsmain.e08ec978.svg";